export var Component = function Component() {
  return false;
};